import {Subscription} from "rxjs";
import {Directive, OnDestroy} from "@angular/core";
import {AbstractControl, FormControl, FormGroup} from "@angular/forms";

/// Directive annotation is here to avoid compile time error
/// https://stackoverflow.com/questions/63126067/class-is-using-angular-features-but-is-not-decorated-please-add-an-explicit-ang
@Directive()
export abstract class AbstractComponent implements OnDestroy {

  protected subscriptions: Array<Subscription> = [];

  constructor() {
  }

  removeError(control: FormControl | FormGroup | AbstractControl, errorName: string): void {
    if (control.errors?.[errorName]) {
      delete control.errors?.[errorName]
    }
    if (Object.keys(control.errors ?? {}).length === 0) {
      control.setErrors(null);
    }
  }

  checkValidators(formGroup: FormGroup): void {
    Object.keys(formGroup.controls).forEach((key: string) => {
      const control: FormControl | FormGroup = formGroup.controls[key] as FormControl | FormGroup;
      if (control instanceof FormControl) {
        if (control.value === "") {
          control.setValue(undefined);
        }
      } else {
        this.checkValidators(control);
      }
    });
  }

  markAllAsTouched(formGroup: FormGroup): void {
    Object.keys(formGroup.controls).forEach((key: string) => {
      const control: FormControl | FormGroup = formGroup.controls[key] as FormControl | FormGroup;
      if (control instanceof FormControl) {
        control.markAsTouched()
      } else {
        this.markAllAsTouched(control);
      }
    });
  }

  markAllAsUntouched(formGroup: FormGroup): void {
    Object.keys(formGroup.controls).forEach((key: string) => {
      const control: FormControl | FormGroup = formGroup.controls[key] as FormControl | FormGroup;
      if (control instanceof FormControl) {
        control.markAsUntouched()
      } else {
        this.markAllAsUntouched(control);
      }
    });
  }

  /**
   * <p>Cleanup the resources claimed by component to avoid memory leaks.</p>
   */
  ngOnDestroy() {
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
  }
}
